/* غصن — تواريخ تقييمات Judge.me بالعربية (2026-08-31)
   Judge.me يعيد كتابة التاريخ بعد العرض وعند التصفّح والترتيب، فالتصحيح يُعاد بلا علامة دائمة.
   الجدولة بـ setTimeout لا requestAnimationFrame لأن الأخير يتوقف حين تكون اللسانة في الخلفية. */
(function () {
  if (window.__ghosnJdgmDates) { return; }
  window.__ghosnJdgmDates = true;

  var MONTHS = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];
  var DIGITS = '٠١٢٣٤٥٦٧٨٩';
  var RIYADH_OFFSET_MS = 3 * 60 * 60 * 1000;
  var queued = false;

  function toArabicDigits(value) {
    return String(value).replace(/[0-9]/g, function (c) { return DIGITS.charAt(+c); });
  }

  function format(raw) {
    var m = String(raw || '').match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})/);
    if (!m) { return null; }
    var d = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +m[6]) + RIYADH_OFFSET_MS);
    return toArabicDigits(d.getUTCDate()) + ' ' + MONTHS[d.getUTCMonth()] + ' ' + toArabicDigits(d.getUTCFullYear());
  }

  function fix() {
    var els = document.querySelectorAll('.jdgm-rev__timestamp[data-content]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var text = format(el.getAttribute('data-content'));
      if (text && el.textContent !== text) { el.textContent = text; }
    }
  }

  function schedule() {
    if (queued) { return; }
    queued = true;
    setTimeout(function () { queued = false; fix(); }, 40);
  }

  fix();
  schedule();
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', schedule); }
  window.addEventListener('load', schedule);
  document.addEventListener('click', schedule, true);
  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }
  var ticks = 0;
  var timer = setInterval(function () { ticks++; fix(); if (ticks > 60) { clearInterval(timer); } }, 500);
})();
